
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"100","cy":"100","r":"100"}}),_c('path',{attrs:{"d":"M51.45 113.54L85.53 135l58.49-73.48","fill":"none","stroke":"#fff","stroke-width":"18.985","stroke-linecap":"round"}})])
          )
        }
      }
    